import React, { useState, useEffect } from "react";
import LoginContext from "./LoginContext";
import { Fetchdata } from "../hooks/getData";
import { toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
function LoginState(props) {
      const [listValues, setListValues] = useState();
    //   to show category
    const [originalList, setOriginalList] = useState(null);
    const [formList, setFormList] = useState([]);
    const [tbid, setTbid] = useState(null);
    const [via, setVia] = useState(null);
    const [hotelID, setHotelID] = useState(""); // State for storing ComID
    const [slug, setSlug] = useState(null);
    const [responseData, setResponseData] = useState(null);
   const [filteredData, setFilteredData] = useState([]); // Filtered data for search
    const navigate = useNavigate();
    useEffect(() => {
      if (hotelID) {
        formLst();
      }
    }, [hotelID, listValues]); // Add hotelID to dependencies

              // Fetch menu data using slug
              const fetchMenuBySlug = async (slug) => {
                try {
                  const response = await fetch("https://testing.esnep.com/ehotel/api/waiter/menu-qr", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      Flag: "SLUG",
                      Slug: slug,
                    }),
                  });
              
                  const data = await response.json();
              
                  if (data.StatusCode === 200) {
                    console.log("API Response:", data.Values);
              
                    if (Array.isArray(data.Values) && data.Values.length > 0) {
                      setResponseData(data.Values);
                      setFilteredData(data.Values); // Initialize filteredData with full menu data
                      
                      // ✅ Set ComID (HotelID) from response
                      if (data.Values[0]?.ComID) {
                        console.log("ComID received:", data.Values[0].ComID); // ✅ Debugging log
                        setHotelID(data.Values[0].ComID);
                      }
                    } else {
                      console.error("Values array is empty or invalid.");
                      navigate("/404");
                    }
                  } else {
                    console.error("API Error:", data.Message);
                    navigate("/404");
                  }
                } catch (error) {
                  console.error("Network Error:", error);
                  navigate("/404");
                }
              };
      
      
              useEffect(() => {
                if (slug) {
                  fetchMenuBySlug(slug);
                }
              }, [slug]);

    const formLst = () => {
        const params = {
        HotelID: hotelID,
        Flag: "CATEGORY",
          FetchURL: 'https://testing.esnep.com/ehotel/api/waiter/menu-qr',
          Type: "POST",
        };
    
        Fetchdata(params).then(function (resp) {
          if (resp.StatusCode === 200) {
            const postResult = resp.Values ? resp.Values : "";
            setFormList(postResult);
            setOriginalList(postResult);
            
          } else {
            setFormList([]);
            setOriginalList([]);
          
          }
        });
      };





        // Function to call the API when the button is clicked
  const callWaiter = async () => {
    const payload = { HotelID: hotelID, Flag: "NOTIFY_WAITER", TableID: tbid, IsNotify: "Y", Via: via };
    try {
      const response = await fetch("https://testing.esnep.com/ehotel/api/waiter/menu-qr", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("Something went wrong");
      const data = await response.json();
      console.log(data);
      toast.success("Waiter has been notified!", { position: "top-center" });
    } catch (err) {
      console.error(err);
      toast.error("Failed to notify waiter.", { position: "top-center" });
    }
  };


    //   to show items
    const [itemList, setItemList] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(-1);
    useEffect(() => {
        if (selectedCategoryId) {
          itemLst(selectedCategoryId);  // Fetch items whenever the selected category changes
        }
      }, [selectedCategoryId]);  // Dependency array ensures this runs when selectedCategoryId changes
    
    useEffect(() => {
      if (hotelID) {
        itemLst();
      }
      }, [hotelID,listValues]);


    const itemLst = (CategoryID= -1) => {
        const params = {
        HotelID: hotelID,
        Flag: "ITEM",
        CategoryID:CategoryID,
        FetchURL: 'https://testing.esnep.com/ehotel/api/waiter/menu-qr',
          Type: "POST",
        };
    
        Fetchdata(params).then(function (resp) {
          if (resp.StatusCode === 200) {
            const postResult = resp.Values ? resp.Values : "";
            setItemList(postResult);
            setOriginalList(postResult);
            
          } else {
            setItemList([]);
            setOriginalList([]);
          
          }
        });
      };
    

      return (
        <LoginContext.Provider
          value={{
            formList,
        setFormList,
        setItemList,
        itemList,
        formLst,
        originalList,
        setOriginalList,
        listValues,
        setListValues,
        setSelectedCategoryId,
        selectedCategoryId,

        callWaiter,
        tbid, setTbid,
        via,setVia,hotelID, setHotelID,setSlug,responseData,filteredData,setFilteredData
        }}
        >
          {props.children}
        </LoginContext.Provider>
      );

}



export default LoginState;